export*from"./dark";export*from"./light";import*as m from"./new";export{m as newThemes};
//# sourceMappingURL=index.js.map
